import { useEffect, useState } from 'react';
import { useResourcesWithPII, useSharedServiceState } from '@getvim/internal-vim-os-sdk/react';
import { PatientSourceVaultToken } from '../types';
import { eligibilityLogger } from '../utils/logger';
import { getPatientInsurance } from '../utils/insurer.utils';
import { AppPatient } from '../types';
import { analyticsManager } from '../utils/analyticManager';

export function usePatientLookupSharedService(): AppPatient | undefined {
  const {
    ehrState: { patient: ehrPatient },
  } = useResourcesWithPII();

  const serviceState = useSharedServiceState();

  const [patientLookupResponse, setPatientLookupResponse] = useState<{
    patientSourceVaultTokens: PatientSourceVaultToken[];
    patientToken: string;
  }>();

  const [patient, setPatient] = useState<AppPatient | undefined>();

  useEffect(() => {
    const { 'patient-lookup-service': patientLookupService } = serviceState;
    if (patientLookupService) {
      const { patientLookupResponse: patientLookupServiceResponse } =
        patientLookupService.customMessage.payload;
      if (patientLookupServiceResponse.patientToken !== patientLookupResponse?.patientToken) {
        setPatientLookupResponse(patientLookupServiceResponse);
      } else {
        eligibilityLogger.info(
          'Received new patient-lookup-service event for same patientToken. skipping',
        );
      }
    }
  }, [serviceState]);

  useEffect(() => {
    if (
      ehrPatient &&
      patientLookupResponse &&
      patientLookupResponse.patientToken === ehrPatient.token
    ) {
      eligibilityLogger.info('Initialize AppPatient with patientSourceVaultTokens', {
        patientId: ehrPatient?.identifiers?.ehrPatientId,
        patientToken: ehrPatient?.token,
      });
      const patientSourceVaultTokens = patientLookupResponse.patientSourceVaultTokens;

      const patientInsurance = getPatientInsurance(ehrPatient.insurance, patientSourceVaultTokens);

      analyticsManager.setPatientBaseProperties({
        vimPatientId: ehrPatient.identifiers.vimPatientId,
        ehrInsurance: patientInsurance?.ehrInsurance,
        insurer: patientInsurance?.insurer,
      });
      setPatient({
        ...ehrPatient,
        patientSourceVaultTokens: patientLookupResponse.patientSourceVaultTokens,
        insurance: patientInsurance,
      });
    } else {
      eligibilityLogger.info(
        'Reset AppPatient- ehrPatient and patientSourceVaultTokens are not matched for same patient',
        {
          ehrPatientToken: ehrPatient?.token,
          patientLookupToken: patientLookupResponse?.patientToken,
        },
      );

      setPatient(undefined);
    }
  }, [patientLookupResponse, ehrPatient]);

  return patient;
}
